import dayjs from 'dayjs';
import store from '../store';

class calculateHolidayDates {
    static async handle(newYearMonth, oldYearMonth, holidayList) {
        const [newYear, newMonth] = newYearMonth ? newYearMonth.split('-') : [];
        const [oldYear] = oldYearMonth ? oldYearMonth.split('-') : [];
        let holidays = holidayList;

        if (!holidays || newYear !== oldYear) {
            holidays = await store.dispatch('holidays/fetchForYear', {
                year: newYear,
                useMutation: false
            });
        }

        const holidayDates = holidays
            .filter(
                ({ date }) => dayjs(date).month() === parseInt(newMonth) - 1
            )
            .map(({ date }) => dayjs(date).date());

        return { holidayDates, holidays };
    }
}

export default calculateHolidayDates;
